<template>
  <div class="rights-list">
    <v-banner color="error" dark v-if="fetchAllError">
      <v-icon slot="icon" color="white" size="36"
        >mdi-wifi-strength-alert-outline</v-icon
      >
      {{ errorDisplay(fetchAllError) }}
      <template v-slot:actions>
        <v-btn text color="dark" @click="refresh">Retry</v-btn>
      </template>
    </v-banner>
    <v-banner>
      <v-avatar slot="icon" size="40">
        <v-icon>info</v-icon>
      </v-avatar>
      <div class="title-1">Tips</div>
      <div v-if="displayInfo" class="caption">
        <span
          >This page is only visible by organization administrators and
          editors.</span
        >
        <span>As an organization editor, you can:</span>
        <ul>
          <li>
            <strong>Mange which user has access</strong> to a specific location
            as an admin (can read, write, delete data), as an editor (can only
            read and write data), as a viewer (can only read data).
          </li>
          <li>
            <strong>Mange which user has access</strong> to a specific concept
            as an admin (can read, write, delete data), as an editor (can only
            read and write data), as a viewer (can only read data).
          </li>
        </ul>
      </div>
      <template v-slot:actions>
        <v-btn text color="dark" @click="displayInfo = !displayInfo">{{
          displayInfo ? "Hide" : "Show"
        }}</v-btn>
      </template>
    </v-banner>
    <v-tabs v-model="tab" background-color="primary" dark icons-and-text grow>
      <v-tab href="#tab-locations">
        <span class="mt-2">Locations</span>
        <v-icon>location_on</v-icon>
      </v-tab>
      <v-tab-item value="tab-locations" class="grey lighten-5">
        <RightsLocations />
      </v-tab-item>
      <v-tab href="#tab-concepts">
        <span class="mt-2">Concepts</span>
        <v-icon>fastfood</v-icon>
      </v-tab>
      <v-tab-item value="tab-concepts" class="grey lighten-5">
        <RightsConcepts />
      </v-tab-item>
      <v-tab href="#tab-users">
        <span class="mt-2">Users</span>
        <v-icon>mdi-account</v-icon>
      </v-tab>
      <v-tab-item value="tab-users" class="grey lighten-5">
        <RightsUsers />
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="openOrgaSelector" persistent max-width="600">
      <v-card>
        <v-card-title>Please select your organization</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="orga in organizations" :key="orga.uuid">
              <v-list-item-icon>
                <v-icon>apartment</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                <v-list-item-content>{{ orga.name }}</v-list-item-content>
              </v-list-item-title>
              <v-list-item-action>
                <v-btn color="success" @click="selectOrganization(orga)"
                  >Select</v-btn
                >
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import RightsLocations from "./RightsLocations";
import RightsConcepts from "./RightsConcepts";
import RightsUsers from "./RightsUsers";

export default {
  mixins: [mixin],
  components: {
    RightsLocations,
    RightsConcepts,
    RightsUsers,
  },
  data() {
    return {
      snackbar: false,
      openOrgaSelector: false,
      errorMessage: "",
      tab: null,
      displayInfo: false,
    };
  },
  computed: {
    ...mapState({
      currentOrganization: (state) => state.organizations.current,
      organizations: (state) => state.organizations.all,
      fetchAllError: (state) => state.organizations.fetchAll.error,
    }),
  },
  watch: {
    currentOrganization() {
      this.refresh();
    },
  },
  methods: {
    ...mapActions("organizations", {
      setCurrentOrganization: "setCurrentOrganization",
    }),
    refresh() {},
    selectOrganization(organization) {
      this.setCurrentOrganization({ organization: organization });
      this.openOrgaSelector = false;
    },
  },
  created() {
    if (this.currentOrganization) {
      this.refresh();
    } else {
      this.openOrgaSelector = true;
    }
  },
};
</script>

<style></style>
